import { useQuery } from '@tanstack/react-query';

import { DispensariesApi } from 'api';
import { DISPENSARY_S2S_CONFIG_KEY } from '../../keys';

export function useDispensaryS2sConfig(dispensaryId: string, shouldNotifyOnChange = true) {
  const dispensariesApi = new DispensariesApi();

  const { data: s2sConfig, isLoading: isLoadingS2sConfig } = useQuery({
    enabled: !!dispensaryId.length,
    queryKey: [DISPENSARY_S2S_CONFIG_KEY, dispensaryId],
    queryFn: () => dispensariesApi.getS2sConfig(dispensaryId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  return { s2sConfig, isLoadingS2sConfig };
}
